// Loom URL handling. Loom share links look like
// https://www.loom.com/share/<id> and embeds like https://www.loom.com/embed/<id>;
// both carry the same 32-char hex video id. We normalize either form (ignoring
// any ?query) to the canonical embed URL the iframe and sanitizer expect.
const LOOM_ID = /^\/(?:share|embed)\/([0-9a-f]{16,})/i

export function parseLoomId(url: string): string | null {
  let parsed: URL
  try {
    parsed = new URL(url.trim())
  } catch {
    return null
  }
  if (!/(^|\.)loom\.com$/.test(parsed.hostname)) return null
  const match = parsed.pathname.match(LOOM_ID)
  return match ? match[1] : null
}

export function getLoomEmbedUrl(url: string): string | null {
  const id = parseLoomId(url)
  return id ? `https://www.loom.com/embed/${id}` : null
}

export function isValidLoomUrl(url: string): boolean {
  return parseLoomId(url) !== null
}

// Mirrors HelpContentSanitizer's loom allowlist (prefix only). Used to
// re-hydrate a stored/imported bare Loom embed iframe: the sanitizer keeps it
// on src prefix alone, so the editor must recognize the same set or the embed
// silently vanishes on the next save. Deliberately looser than parseLoomId,
// which gates paste/dialog input on a plausible id.
const LOOM_EMBED = /^https:\/\/(www\.)?loom\.com\/embed\/\S+/i

export function isLoomEmbedUrl(url: string): boolean {
  return LOOM_EMBED.test(url.trim())
}
